import styled from 'styled-components'

const ErrorMessageTitle = styled.h1`
  &&& {
    text-align: center;
  }
`

const ErrorMessageText = styled.p`
  &&& {
    margin-bottom: 40px;
    text-align: center;
  }
`

const Column = styled.div`
  &&& {
    display: block;
    margin: 80px auto;
    float: none;
    max-width: 420px;
  }
`

const Controls = styled.ul`
  list-style: none outside none;
  margin: 0;
  padding: 0;

  li + li {
    margin-top: 30px;
  }
`

const ButtonBlue = styled.a`
  color: ${props => props.theme.color.palette['brand-1']};
  text-align: center;
  text-transform: uppercase;
  padding: 5px 7px;
  font-size: 15px;
  font-weight: ${props => props.theme.font.weight.bold};
  height: 35px;
  border: 1px solid ${props => props.theme.color.monochrome.light};
  background: ${props => props.theme.color.monochrome.white};
  width: 100%;
  display: block;
`

export { ErrorMessageTitle, ErrorMessageText, Column, Controls, ButtonBlue }
